import { render, staticRenderFns } from "./ClientCart.vue?vue&type=template&id=6c233804&scoped=true&"
import script from "./ClientCart.vue?vue&type=script&lang=js&"
export * from "./ClientCart.vue?vue&type=script&lang=js&"
import style0 from "./ClientCart.vue?vue&type=style&index=0&id=6c233804&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c233804",
  null
  
)

export default component.exports